import React, { Component, Fragment } from 'react';
import {Helmet} from "react-helmet";
import Breadcrumb from "../../common/breadcrumb";
import {clear_auth, set_auth} from "../../../reducers/Auth";
import {connect} from "react-redux";
import SearchIcon from "../../../assets/icons/search.svg";
import RefreshIcon from "../../../assets/icons/refresh.svg";
import {Empty, Spin, Tooltip} from "antd";
import {pageNumber} from "../../../functions/functionGeneral";
import Paging from "../../paging";
import PlusIcon from "../../../assets/icons/plus-white.svg";
import Add from "./add";
import Edit from "./edit";
import Swal from "sweetalert2";
import refreshIcon from "../../../assets/icons/refresh.svg";
import {TourContext} from "../../guideComponent/guideTourProvicer";

export class Istilah_Invnetaris extends Component {
    static contextType = TourContext;
    constructor(props) {
        super(props);
        this.state = {
            data : [],
            currentPage : 0,
        }
        this.handlePageClick = this.handlePageClick.bind(this)
    }

    handleChange = (event) => {
        const { name, value } = event.target;

        this.setState({
            [name]: value,
        })
    }

    loadData() {
        this.setState({loading: true})
        let form = {
            filter_nama : this.state.filter_nama,
            paginate    : 10,
            page        : this.state.currentPage + 1,
        }
        this.props.request("inventaris_term/list", form, 'POST')
            .then(response => {
                if (response.success) {
                    this.setState({
                        data: response.data.data,
                        loading: false,
                        totalData: response.data.total,
                        pageCount: response.data.last_page,
                        perPage: response.data.per_page,
                    })
                }
            });
    }

    handleDelete() {
        Swal.fire({
            title: 'Pemberitahuan!',
            text: 'Anda yakin ingin menghapus inventaris?',
            icon: 'warning',
            confirmButtonText: 'Ya',
            showCancelButton: true,
            cancelButtonText: 'Batal',
        })
            .then((result) => {
                if (result.isConfirmed) {
                    let form = {
                        inv_term_id    : this.state.inv_term_id
                    }
                    this.props.request("inventaris_term/delete", form, 'POST')
                        .then(response => {
                            if (response.success) {
                                Swal.fire({
                                    title: 'Berhasil!',
                                    text: response.message,
                                    icon: 'success',
                                    showConfirmButton: false,
                                    timer: 800,
                                })
                                this.loadData()
                            }
                        })
                }
            })
    }

    handlePageClick(data) {
        let selected = data.selected
        this.setState({ currentPage: selected }, () => {
            this.loadData()
        });
    }

    clear = () => {
        this.setState({
            modal_edit      : false,
            modal_add       : false,
            inv_term_name   : ''
        })
    }

    componentDidMount() {
        this.loadData()
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.loading === true && this.state.loading === false) {
            this.tourTimeout = setTimeout(() => {
                const tourSteps = [
                    {
                        selector: '.fltr-nama',
                        title: 'Cari Nama Term',
                        content: 'Gunakan kolom pencarian ini untuk menemukan data term inventaris berdasarkan nama term.'
                    },
                    {
                        selector: '.button-reset',
                        title: 'Muat Ulang Data',
                        content: 'Klik tombol ini untuk mengosongkan pencarian dan memuat ulang daftar term inventaris.'
                    },
                    {
                        selector: '.width-filter',
                        title: 'Tambah Term',
                        content: 'Klik tombol ini untuk menambahkan term inventaris baru ke dalam sistem.'
                    }
                ];

                if (!this.state.loading && this.state.data.length === 0) {
                    tourSteps.push({
                        selector: '.table-responsive',
                        title: 'Daftar Term Inventaris (Kosong)',
                        content: 'Belum ada data term inventaris yang tersedia. Gunakan tombol "Tambah" untuk menambahkan data baru.'
                    });
                } else {
                    tourSteps.push(
                        {
                            selector: '.table',
                            title: 'Daftar Term Inventaris',
                            content: `Tabel ini menampilkan ${this.state.data.length} data term inventaris yang tersedia di sistem.`
                        },
                        {
                            selector: '.fa-ellipsis-v',
                            title: 'Aksi',
                            content: 'Klik ikon ini untuk membuka menu aksi pada data term inventaris, seperti edit atau hapus data.'
                        }
                    );
                }

                const { setSteps, setCurrent, setActive } = this.context;
                setSteps(tourSteps);
                setCurrent(0);
                setActive(true);
            }, 500);
        }
    }

    componentWillUnmount() {
        clearTimeout(this.tourTimeout);
    }

    render() {
        let no = 0;
        return (
                <Fragment>
                    <Helmet>
                        <meta charSet="utf-8"/>
                        <title>Daftar Istilah Inventaris - iPresens</title>
                        <meta name="description" content="Daftar Istilah Inventaris"/>
                    </Helmet>
                    <Breadcrumb parent="Inventaris" title="Daftar Istilah Inventaris" parentLink="/inventaris"/>

                    <Add
                        handleChange={this.handleChange}
                        modal_add={this.state.modal_add}
                        inv_term_name={this.state.inv_term_name}
                        clear={this.clear}
                        request={(action, data, method = 'GET') => this.props.request(action, data, method)}
                        changeState={(state, callback) => {
                            this.setState(state, () => {
                                if (typeof callback != 'undefined')
                                    callback()
                            })
                        }}
                        loadData={() => this.loadData()}
                    />
                    <Edit
                        handleChange={this.handleChange}
                        modal_edit={this.state.modal_edit}
                        data={this.state}
                        clear={this.clear}
                        request={(action, data, method = 'GET') => this.props.request(action, data, method)}
                        changeState={(state, callback) => {
                            this.setState(state, () => {
                                if (typeof callback != 'undefined')
                                    callback()
                            })
                        }}
                        loadData={() => this.loadData()}
                    />

                    <div className="container-fluid">
                        <div className="card">
                            <div className="card-header">
                                <div className="row">
                                    <div className="col-md-5 d-flex">
                                        <input type='text' onChange={this.handleChange}
                                               name='filter_nama' value={this.state.filter_nama}
                                               className="form-control fltr-nama mr-2 mb-2"
                                               placeholder="&#xF002;  Cari nama term..."
                                               onKeyDown={(e) => {
                                                   if (e.key === "Enter") {
                                                       this.loadData()
                                                   }
                                               }}
                                        />
                                        <div>
                                            <button className="input-select-style button-reset mt-0"
                                                    style={{width: "44px"}} onClick={() => {
                                                this.setState({
                                                    filter_nama: ""
                                                }, () => this.loadData())
                                            }}>
                                                <img src={refreshIcon} alt=""/>
                                            </button>
                                        </div>
                                    </div>
                                    <div className="col-md-7 justify-content-end">
                                        <button
                                            className="btn btn-primary text-capitalize width-filter pull-right"
                                            onClick={() => {
                                                this.setState({modal_add: true});
                                            }}
                                        >
                                            <img src={PlusIcon} alt=""/> Tambah
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="table-responsive">
                                            {!this.state.loading && this.state.data.length === 0 ?
                                                <Empty description="Data Kosong"
                                                       image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"/>
                                                :
                                                <div>
                                                    <table className="table mb-5 table-striped table-borderless">
                                                        <thead>
                                                        <tr>
                                                            <th className='lembur-th-style text-center' width="50">#
                                                            </th>
                                                            <th className='lembur-th-style'>Nama</th>
                                                            <th className='lembur-th-style text-center'>Aksi</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        {this.state.loading ?
                                                            <tr>
                                                                <td colSpan="9" style={{
                                                                    textAlign: "center",
                                                                    backgroundColor: "#FFFFFF"
                                                                }}>
                                                                    <Spin size="large" tip="Loading..." style={{
                                                                        width: '100%',
                                                                        margin: 'auto',
                                                                        marginBottom: '10px',
                                                                        marginTop: '10px'
                                                                    }} />
                                                                </td>
                                                            </tr>
                                                            :
                                                            this.state.data.map((item, index) => {
                                                                no += 1
                                                                return (
                                                                    <tr key={index}>
                                                                        <td className="lembur-td-style text-center">{pageNumber(no, this.state.perPage, this.state.currentPage)}</td>
                                                                        <td className="lembur-td-style">{item.inv_term_name}</td>
                                                                        <td className="lembur-td-style text-center">
                                                                            <Tooltip trigger={'click'} zIndex={1}
                                                                                     placement="bottom" color={'#fff'}
                                                                                     title={
                                                                                         <div className={'text-dark'}>
                                                                                             <a onClick={() => {
                                                                                                 this.setState({
                                                                                                     inv_term_id: item.inv_term_id,
                                                                                                     inv_term_name: item.inv_term_name,
                                                                                                     modal_edit: true
                                                                                                 })
                                                                                             }}>Edit</a><br/>
                                                                                             <a onClick={() => {
                                                                                                 this.setState({
                                                                                                     inv_term_id: item.inv_term_id,
                                                                                                 })
                                                                                                 this.handleDelete()
                                                                                             }}
                                                                                                className={'text-danger'}>Hapus</a>
                                                                                         </div>
                                                                                     }>
                                                                                <a><i
                                                                                    className="fa fa-ellipsis-v"
                                                                                    style={{
                                                                                        width: 35,
                                                                                        fontSize: 18,
                                                                                        padding: 11,
                                                                                        color: 'rgb(51 51 51)'
                                                                                    }}
                                                                                ></i></a>
                                                                            </Tooltip>
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            })}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            }
                                        </div>
                                        <div className="row">
                                            <div className='col font-14 fw-500 m-auto'>
                                                Menampilkan {this.state.data.length === 0 || this.state.data.length === null ? "0" : this.state.data.length} dari {this.state.totalData} Data.
                                            </div>
                                            <div className="col">
                                                <Paging
                                                    className="float-right"
                                                    handlePageClick={this.handlePageClick}
                                                    pageCount={this.state.pageCount}
                                                    currentPage={this.state.currentPage}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Fragment>
        )
    }
}

const mapStateToProps = state => ({
    user: state.Auth.user,
    api_token: state.Auth.api_token
});

const mapDispatchToProps = dispatch => ({
    clear_auth: () => dispatch(clear_auth()),
    set_auth: (api_token, data) => dispatch(set_auth(api_token, data))
})

export default connect(mapStateToProps, mapDispatchToProps)(Istilah_Invnetaris);